import cellConfigMap from './cellConfigMap';
import _ from 'lodash';

const defaultCellConfig = {
  null: {
    name: '自定义列',
    list: [
      {
        name: '默认指标',
        columns: [
          {
            name: 'name',
            displayName: '姓名',
            cellName: '姓名',
            align: 'left',
            required: true,
            if_default: true,
            privilege: 'ALL',
          },
          {
            name: 'tel',
            displayName: '电话',
            cellName: '电话',
            align: 'left',
            required: true,
            if_default: true,
            privilege: 'ALL',
          },
          {
            name: 'leadsFollowTagName',
            displayName: '线索状态',
            cellName: '线索状态',
            align: 'left',
            required: true,
            if_default: true,
            privilege: 'ALL',
          },
          {
            name: 'leadsOpt',
            displayName: '操作',
            cellName: '操作',
            align: 'left',
            required: true,
            if_default: true,
            privilege: 'ALL',
          },
        ],
      },
      {
        name: '用户信息',
        columns: [
          {
            name: 'leadsId',
            displayName: '线索ID',
            cellName: '线索ID',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'telLocation',
            displayName: '号码归属地',
            cellName: '号码归属地',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'name',
            displayName: '姓名',
            cellName: '姓名',
            align: 'left',
            required: true,
            if_default: true,
            privilege: 'ALL',
            width: 180,
          },
          {
            name: 'tel',
            displayName: '电话',
            cellName: '电话',
            align: 'left',
            required: true,
            if_default: true,
            privilege: 'ALL',
          },
          {
            name: 'wechat',
            displayName: '微信',
            cellName: '微信',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'qq',
            displayName: 'QQ',
            cellName: 'QQ',
            align: 'right',
            privilege: 'ALL',
          },
          {
            name: 'email',
            displayName: '邮箱',
            cellName: '邮箱',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'idNumber',
            displayName: '身份证',
            cellName: '身份证',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'sex',
            displayName: '性别',
            cellName: '性别',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'age',
            displayName: '年龄',
            cellName: '年龄',
            align: 'right',
            privilege: 'ALL',
          },
          {
            name: 'profession',
            displayName: '职业',
            cellName: '职业',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'company',
            displayName: '公司',
            cellName: '公司',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'workingYears',
            displayName: '工作年限',
            cellName: '工作年限',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'nationality',
            displayName: '国籍',
            cellName: '国籍',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'area',
            displayName: '所在地',
            cellName: '所在地',
            align: 'right',
            privilege: 'ALL',
          },
          {
            name: 'address',
            displayName: '详细地址',
            cellName: '详细地址',
            align: 'left',
            privilege: 'ALL',
          },
          // add by fightingliu
          {
            name: 'customQa',
            displayName: '互动内容',
            cellName: '互动内容',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'bundle',
            displayName: '表单信息',
            cellName: '表单信息',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'ownerName',
            displayName: '当前归属人',
            cellName: '当前归属人',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'messageContent',
            displayName: '留言内容',
            cellName: '留言内容',
            align: 'left',
            privilege: 'ALL',
          },
          cellConfigMap.outerLeadsId,
          cellConfigMap.accountId,
          cellConfigMap.layerFormContent,
          cellConfigMap.matchedWxWorkUserId,
          cellConfigMap.matchedExternalUserName,
        ],
      },
      {
        name: '广告投放信息',
        columns: [
          {
            name: 'advertiserId',
            displayName: '推广账号',
            cellName: '推广账号',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'campaignId',
            displayName: '推广计划',
            cellName: '推广计划',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'adName',
            displayName: '广告',
            cellName: '广告',
            align: 'left',
            privilege: 'ALL',
          },
          cellConfigMap.placementName,
          {
            name: 'creativeId',
            displayName: '创意(待废弃)',
            cellName: '创意(待废弃)',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'creativeIdNew',
            displayName: '投放端创意',
            cellName: '投放端创意',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'adCreativeId',
            displayName: 'mkt api创意',
            cellName: 'mkt api创意',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'pageId',
            displayName: '落地页',
            cellName: '落地页',
            align: 'right',
            privilege: 'ALL',
          },
          {
            name: 'componentId',
            displayName: '组件',
            cellName: '组件',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'pageUrl',
            displayName: '推广链接',
            cellName: '推广链接',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'shopName',
            displayName: '门店名称',
            cellName: '门店名称',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'shopAddress',
            displayName: '门店地址',
            cellName: '门店地址',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'consultUrl',
            displayName: '咨询页URL',
            cellName: '咨询页URL',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'searchQueryWord',
            displayName: '搜索词',
            cellName: '搜索词',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'searchKeyWord',
            displayName: '关键词',
            cellName: '关键词',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'clickId',
            displayName: '点击ID',
            cellName: '点击ID',
            align: 'left',
            privilege: 'ALL',
          },
        ],
      },
      {
        name: '系统信息',
        columns: [
          {
            name: 'touchTagName',
            displayName: '接通状态',
            cellName: '接通状态',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'leadsFollowTagName',
            displayName: '线索状态',
            cellName: '线索状态',
            align: 'left',
            required: true,
            if_default: true,
            privilege: 'ALL',
          },
          {
            name: 'leadsTagDesc',
            displayName: '线索标签',
            cellName: '线索标签',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'leadsCallCleaningTagName',
            displayName: '智能标签',
            cellName: '智能标签',
            required: true,
            if_default: true,  // 默认展示 by fightingliu
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'intentionScoreTagName',
            displayName: '线索评分',
            cellName: '线索评分',
            align: 'right',
            privilege: 'ALL',
          },
          {
            name: 'actionSubType',
            displayName: '线索类型',
            cellName: '线索类型',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'leadsSourceName',
            displayName: '线索来源',
            cellName: '线索来源',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'actionTime',
            displayName: '线索提交时间',
            cellName: '线索提交时间',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'ownerLastChangedTime',
            displayName: '线索分配时间',
            cellName: '线索分配时间',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'relatedLeadsIds',
            displayName: '关联线索ID',
            cellName: '关联线索ID',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'mobileVerifyMethod',
            displayName: '验证状态',
            cellName: '验证状态',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'allFollowRecords',
            displayName: '全部跟进记录',
            cellName: '全部跟进记录',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'outerLeadsConvertType',
            displayName: '自定义线索状态',
            cellName: '自定义线索状态',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'outerLeadsInEffectReason',
            displayName: '自定义无效原因',
            cellName: '自定义无效原因',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'callTimes',
            displayName: '通话次数',
            cellName: '通话次数',
            align: 'left',
            privilege: 'ALL',
          },
          {
            name: 'isBroadCastLeads',
            displayName: '是否多发线索',
            cellName: '是否多发线索',
            align: 'left',
            privilege: 'ALL',
          },
        ],
      },
    ],
  },
};

export const getCellsConfig = (customizedAttributes = []) => {
  const cellsConfig = _.cloneDeep(defaultCellConfig);
  if (customizedAttributes.length > 0) {
    cellsConfig.null.list = [
      ...cellsConfig.null.list,
      {
        name: '自定义属性',
        columns: customizedAttributes.map((v) => ({
          name: v.name,
          displayName: v.name,
          cellName: v.name,
          align: 'left',
          privilege: 'ALL',
        })),
      },
      ...(window.pageProps.isInnerAccount
        ? [
            {
              name: '内部信息',
              columns: [
                {
                  name: 'sourceAccountId',
                  displayName: '来源广告主ID',
                  cellName: '来源广告主ID',
                  align: 'left',
                  privilege: 'ALL',
                },
                {
                  name: 'sourceLeadsId',
                  displayName: '来源线索ID',
                  cellName: '来源线索ID',
                  align: 'left',
                  privilege: 'ALL',
                },
                {
                  name: 'lgMethod',
                  displayName: 'LG处理方式',
                  cellName: 'LG处理方式',
                  align: 'left',
                  privilege: 'ALL',
                },
              ],
            },
          ]
        : []),
    ];
  }
  return cellsConfig;
};

export default defaultCellConfig;
